import * as THREE from 'three'
import { OrbitControls } from './OrbitControls.js';
export default class PalletModel {
    constructor(pallet) {
        this.pallet = pallet;
        init(pallet);
        animate();
    }
}
let camera, controls, scene, renderer

async function init(pallet) {
    const parent = document.getElementById("pallet-3d");
    scene = new THREE.Scene();
    scene.background = new THREE.Color(0xcccccc);
    // scene.fog = new THREE.FogExp2(0xcccccc, 0.002);

    let width = parent.clientWidth - 5, height = parent.clientHeight - 10;
    renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(width, height);
    
    parent.replaceChild(renderer.domElement, parent.childNodes[0]);

    camera = new THREE.PerspectiveCamera(10, width / height, 1, 1000);
    camera.position.set(-250, 85, 90);

    controls = new OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true; // an animation loop is required when either damping or auto-rotation are enabled
    controls.dampingFactor = 0.05;
    controls.screenSpacePanning = false;
    controls.minDistance = 100;
    controls.maxDistance = 500;
    controls.maxPolarAngle = Math.PI / 2;
    controls.target.set(0, 20, 0);

    //adds given pallet to the screen
    addPallet(pallet);

    var light = new THREE.DirectionalLight(0xffffff);
    light.position.set(1, 1, 1);
    scene.add(light);

    light = new THREE.DirectionalLight(0x002288);
    light.position.set(- 1, - 1, - 1);
    scene.add(light);

    light = new THREE.AmbientLight(0x222222);
    scene.add(light);
    window.addEventListener('resize', onWindowResize, false);
}

function addPallet(pallet) {
    const divider = 100;
    const structure = pallet.pallet_structure;
    addLayer(pallet, structure.layer_1, pallet.width, pallet.pallet_height / 2, 0, "#db2114", divider);
    addLayer(pallet, structure.layer_2, pallet.length, pallet.pallet_height / 4, pallet.pallet_height / 2, "#284d1c", divider, 1);
    addLayer(pallet, structure.layer_3, pallet.width, pallet.pallet_height / 4, pallet.pallet_height * 3 / 4, "#3d0fd6", divider)
    for (const product of pallet.products) {
        const material = makeMaterial(product);
        addProduct(pallet, product, material, divider);
    }
}

function addProduct(pallet, product, material, divider) {
    const geometry = new THREE.BoxGeometry(product.width / divider, product.height / divider, product.depth / divider);
    const mesh = new THREE.Mesh(geometry, material);
    if (product.is_flipped) {
        mesh.rotation.z = Math.PI / 2;
    }
    const rotationDistance = product.is_flipped ? (product.height / 2) - (product.width / 2) : 0;
    mesh.position.x = (product.x + product.width / 2 - pallet.length / 2 + rotationDistance) / divider;
    mesh.position.y = (pallet.pallet_height + (product.getHeight() / 2) + (product.z / 2)) / divider;
    mesh.position.z = (product.y + (product.depth / 2) - (pallet.width / 2)) / divider;
    mesh.updateMatrix();
    mesh.matrixAutoUpdate = false;
    scene.add(mesh);
}

function makeMaterial(/*product*/) {
    return new THREE.MeshFaceMaterial([
        new THREE.MeshBasicMaterial({ color: "#E53935" }),
        new THREE.MeshBasicMaterial({ color: "#D81B60" }),
        new THREE.MeshBasicMaterial({ color: "#8E24AA" }),
        new THREE.MeshBasicMaterial({ color: "#5E35B1" }),
        new THREE.MeshBasicMaterial({ color: "#5E35B1" }),
        new THREE.MeshBasicMaterial({ color: "#5E35B1" }),
    ]);
    // if (product.created_at < "2020-06-02") {
    //     return new THREE.MeshPhongMaterial( { color: "#ebedeb", shininess: 150 } );
    // }
    // const svgData = product.image;
    // const canvas = document.createElement("canvas");
    // canvas.width = 3000;
    // canvas.height = 3000;
    // const ctx = canvas.getContext("2d");
    // const img = document.createElement("img");
    // img.setAttribute("src", "data:image/svg+xml;base64," + window.btoa(unescape(encodeURIComponent(svgData))));

    // img.onload = function () {
    //     ctx.drawImage(img, 0, 0);
    //     const texture = new THREE.Texture(canvas);
    //     texture.needsUpdate = true;

    //     const textureF = new THREE.Texture(canvas);
    //     textureF.wrapS = THREE.RepeatWrapping;
    //     textureF.repeat.x = -1;
    //     textureF.needsUpdate = true;
    //     return new THREE.MeshFaceMaterial([
    //         new THREE.MeshBasicMaterial({ color: "#ffffff" }),
    //         new THREE.MeshBasicMaterial({ color: "#ffffff" }),
    //         new THREE.MeshBasicMaterial({ color: "#ffffff" }),
    //         new THREE.MeshBasicMaterial({ color: "#ffffff" }),
    //         new THREE.MeshBasicMaterial({ map: texture }),
    //         new THREE.MeshBasicMaterial({ map: textureF }),
    //     ]);
    // }
}

function addLayer(pallet, layer, plankLength, plankHeight, startingHeight, color, divider, vertical) {
    let geometry;
    const layerData = layer.split(' ');
    const plankWidth = layerData[1];
    const planks = layerData.slice(2);
    const height = startingHeight + (plankHeight / 2);
    for (const plank of planks) {
        if (vertical) {
            geometry = new THREE.BoxGeometry(plankLength / divider, plankHeight / divider, plankWidth / divider)
        } else {
            geometry = new THREE.BoxGeometry(plankWidth / divider, plankHeight / divider, plankLength / divider)
        }
        let material = new THREE.MeshPhongMaterial({ color: color, flatShading: true });
        let mesh = new THREE.Mesh(geometry, material);
        mesh.position.y = height / divider;
        if (vertical) {
            mesh.position.x = 0;
            mesh.position.z = (plank / divider) + (plankHeight / divider / 2) - (pallet.width / 2 / divider);
        } else {
            mesh.position.x = (plank / divider) + (plankWidth / divider / 2) - (pallet.length / 2 / divider);
            mesh.position.z = 0;
        }
        mesh.updateMatrix();
        mesh.matrixAutoUpdate = false;
        scene.add(mesh);
    }
}

function onWindowResize() {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
}

function animate() {
    requestAnimationFrame(animate);
    controls.update(); // only required if controls.enableDamping = true, or if controls.autoRotate = true
    render();
}

function render() {
    renderer.render(scene, camera);
}